/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@compiled/react';

import Item, { type SwitcherItemProps } from './item';

// add !important to override the default styles
// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const styles = cssMap({
	item: {
		paddingTop: `${token('space.100')} !important`,
		paddingRight: `${token('space.100')} !important`,
		paddingBottom: `${token('space.100')} !important`,
		paddingLeft: `${token('space.100')} !important`,
		borderRadius: `${token('border.radius')} !important`,
	},
	icon: {
		marginRight: `${token('space.negative.050')}`,
	},
});

export default (props: SwitcherItemProps) => {
	const { icon, isDraggable, setIsLinkItemHovered, ...rest } = props;
	return (
		<Item
			icon={<span css={styles.icon}>{icon}</span>}
			{...rest}
			css={styles.item}
			isDraggable={isDraggable}
			setIsLinkItemHovered={setIsLinkItemHovered}
		/>
	);
};
